// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__3OMNJ","question":"Question_question__zgzVk","description":"Question_description__3Mxy0"};